import React, { PureComponent } from "react";
import { MenuItem } from "@mui/material";

export default class SelectItem extends PureComponent {
  render() {
    return (
      <MenuItem {...this.props} classes={{ root: "submenu-item" }}>
        {this.props.children}
      </MenuItem>
    );
  }
}